import { animate, AnimationBuilder, style } from '@angular/animations';
import { DOCUMENT, inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

/** Fades out and removes the static splash screen in index.html once the first navigation settles. */
@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  private readonly router = inject(Router);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly animationBuilder = inject(AnimationBuilder);

  private readonly splashScreenElem?: HTMLElement;

  constructor() {
    this.splashScreenElem = this.document.body.querySelector<HTMLElement>('#rms-splash-screen') ?? undefined;

    if (this.splashScreenElem) {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1)
        )
        .subscribe(() => this.hide());
    }
  }

  public hide(): void {
    const player = this.animationBuilder
      .build([style({ opacity: 1 }), animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0 }))])
      .create(this.splashScreenElem);

    player.onDone(() => this.splashScreenElem?.remove());
    player.play();
  }
}
